import { render, staticRenderFns } from "./Melyepites.vue?vue&type=template&id=d2f52ac4&"
import script from "./Melyepites.vue?vue&type=script&lang=js&"
export * from "./Melyepites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports